export enum TabsNames {
  BallTracking = 'ballTracking',
  PlayerTracking = 'playerTracking',
}

export enum TabsDisplayNames {
  BallTracking = 'Ball Tracking',
  PlayerTracking = 'Player Tracking',
}
